/*
==============================================================================
NUPEP Cart API
Version: 6.0.0

Production Shopify Cart API
Compatible with Shopify Dawn 15+

Responsibilities
----------------
✓ Read Cart
✓ Add Items
✓ Change Quantity
✓ Remove Items
✓ Clear Cart
✓ Safe Shopify Error Handling
✓ Promise-based API

Business logic belongs elsewhere.
==============================================================================
*/

"use strict";

window.NUPEP = window.NUPEP || {};

NUPEP.CartAPI = (() => {
  const JSON_HEADERS = {
    "Content-Type": "application/json",
  };

  async function request(url, body = null) {
    const options = {
      method: body ? "POST" : "GET",
      headers: JSON_HEADERS,
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(url, options);

    let result = {};

    try {
      result = await response.json();
    } catch (e) {
      result = {};
    }

    if (!response.ok) {
      console.error("Shopify Cart API Error");

      console.error(url);

      console.error(body);

      console.error(result);

      throw new Error(
        result.description ||
          result.message ||
          "Shopify Cart API request failed.",
      );
    }

    return result;
  }

  return {
    /*==========================================================
        Get Current Cart
        ==========================================================*/

    async getCart() {
      return request("/cart.js");
    },

    /*==========================================================
        Add Item
        ==========================================================*/

    async add(variantId, quantity = 1, sellingPlan = null, properties = {}) {
      const payload = {
        id: Number(variantId),

        quantity: Number(quantity),
      };

      if (sellingPlan !== null && sellingPlan !== undefined) {
        payload.selling_plan = Number(sellingPlan);
      }

      if (Object.keys(properties).length) {
        payload.properties = properties;
      }

      return request(
        "/cart/add.js",

        payload,
      );
    },

    /*==========================================================
        Change Existing Line
        Supports:
            id  -> line key
            line -> line number
        ==========================================================*/

    async change(identifier, quantity = null, sellingPlan = undefined) {
      const payload = {};

      if (quantity !== null) {
        payload.quantity = Number(quantity);
      }

      if (typeof identifier === "number" || /^[0-9]+$/.test(identifier)) {
        payload.line = Number(identifier);
      } else {
        payload.id = identifier;
      }

      if (sellingPlan === null) {
        payload.selling_plan = "";
      } else if (sellingPlan !== undefined) {
        payload.selling_plan = Number(sellingPlan);
      }

      return request("/cart/change.js", payload);
    },

    /*==========================================================
        Remove Line
        ==========================================================*/

    async remove(identifier) {
      return this.change(
        identifier,

        0,
      );
    },

    /*==========================================================
        Update Quantity
        ==========================================================*/

    async updateQuantity(identifier, quantity) {
      return this.change(
        identifier,

        quantity,
      );
    },

    /*==========================================================
        Clear Cart
        ==========================================================*/

    async clear() {
      return request(
        "/cart/clear.js",

        {},
      );
    },

    /*==========================================================
        Bulk Update
        ==========================================================*/

    async update(updates) {
      return request(
        "/cart/update.js",

        {
          updates,
        },
      );
    },
  };
})();
